import { defaultGrid } from "@helpers/datagrid";
import moment from "moment";
import defaultReducer from "./defaultReducer";

export const kioskDefaultState = {
  filters: {
    fromDate: moment().subtract(1, "days").startOf("day"),
    toDate: moment(),
    collectionDate: null,
    currentDate: true,
    includeEvents: false,
    periodId: 2,
    loading: false,
    useCollectionWeek: 0,
    page: 1,
  },
  activeRow: null,
  transactions: {
    ...defaultGrid,
    pageCount: 1,
  },
  summary: defaultGrid,
  positions: {
    ...defaultGrid,
    optionAllowExport: false,
    collectionDates: [],
  },
  details: defaultGrid,
};

export default defaultReducer("KIOSK_VIEW", kioskDefaultState);
